@if (cart$ | async; as cart) { @if (entries$ | async; as entries) { @if (cart.totalItems > 0) {
<div class="cart-details-wrapper">
  <!-- Cart List for the Cart Page -->
  @if(pagetemplate === cartPageId){ @if (pagetemplate === cartPageId) {
  <div>
    <div class="cart-details-title">
      <h2>{{ 'cart.cartDetails' | cxTranslate }}</h2>
    </div>
    @if (cart.totalItems == 1) {
    <div
      class="cart-details-subtitle subtitle"
      [innerHtml]="'cart.cartDetailsSubtitle' | cxTranslate : { item: cart.totalItems }"
    ></div>
    } @if (cart.totalItems > 1) {
    <div
      class="cart-details-subtitle subtitle"
      [innerHtml]="'cart.cartDetailsSubtitles' | cxTranslate : { item: cart.totalItems }"
    ></div>
    }
    <div class="cart-actions">
      <app-cart-export [cartId]="cart.code"></app-cart-export>
      <app-cart-quick-order></app-cart-quick-order>
      <app-cart-delete [cartId]="cart.code"></app-cart-delete>
    </div>
  </div>
  }
  <div class="collapse show" id="collapseSummary">
    @if (pagetemplate === cartPageId) {
    <div class="error-wrapper">
      @if (defaultCartError) {
      <div class="default-error">
        {{ 'cart.cartValidationError.defaultCartError' | cxTranslate }}
      </div>
      } @if (lowStockError) {
      <div class="lowstock-error">
        {{ 'cart.cartValidationError.lowStockError' | cxTranslate }}
      </div>
      } @if (unapprovedError || noStockError) {
      <div class="grey-item-error">
        {{ 'cart.cartValidationError.greyItemError' | cxTranslate }}
      </div>
      }
    </div>
    }
    <cx-cart-item-list
      [pageId]="pagetemplate"
      [cartPageId]="cartPageId"
      [items]="entries"
      [noStockError]="nostockErrorEntries"
      [lowStockError]="lowstockErrorEntries"
      [unapprovedError]="unapprovedError"
      [cartIsLoading]="!(cartLoaded$ | async)"
      [promotionLocation]="promotionLocation"
      [dateFormatted]="dateFormatted"
      [skipVariantCategory]="skipVariantCategory"
      [options]="{
        isSaveForLater: false,
        optionalBtn: isSaveForLaterEnabled() ? saveForLaterBtn : null
      }"
      [appliedPromotions]="appliedPromotions"
      [showWarehouseFeature]="showActiveSnahCountry$ | async"
    ></cx-cart-item-list>
  </div>
  }@else {
  <!-- Cart List for the Checkout Page -->
  <mat-accordion class="custom-cart-list">
    <mat-expansion-panel [expanded]="true" toggleIndicatorPosition="after">
      <mat-expansion-panel-header class="cart-details-title">
        <mat-panel-title>
          <h2 [innerHTML]="'cart.checkoutDetails' | cxTranslate : { item: cart.totalItems }"></h2>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <cx-cart-item-list
        [pageId]="pagetemplate"
        [cartPageId]="cartPageId"
        [items]="entries"
        [noStockError]="nostockErrorEntries"
        [lowStockError]="lowstockErrorEntries"
        [unapprovedError]="unapprovedError"
        [cartIsLoading]="!(cartLoaded$ | async)"
        [promotionLocation]="promotionLocation"
        [dateFormatted]="dateFormatted"
        [skipVariantCategory]="skipVariantCategory"
        [options]="{
          isSaveForLater: false,
          optionalBtn: isSaveForLaterEnabled() ? saveForLaterBtn : null
        }"
        [appliedPromotions]="appliedPromotions"
        [showWarehouseFeature]="showActiveSnahCountry$ | async"
      ></cx-cart-item-list>
    </mat-expansion-panel>
  </mat-accordion>
  }
</div>
} } }

<ng-template let-ctx #saveForLaterBtn>
  <div class="col-md-3 col-lg-3 col-xl-3 cx-sfl-btn">
    <button class="link" [disabled]="ctx.loading" (click)="saveForLater(ctx.item)">
      {{ 'saveForLaterItems.saveForLater' | cxTranslate }}
    </button>
  </div>
</ng-template>
